import { RoomCapabilities } from '../../../../generated/api/chat-room'

export const hasRoomSettings = (capabilities: RoomCapabilities): boolean =>
  capabilities.canEditRoom ||
  capabilities.canManageMembers ||
  capabilities.canDelete ||
  capabilities.canLeave ||
  capabilities.canArchive
